import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

// 按需引入 Vant 组件
import {
  Button,
  Swipe,
  SwipeItem,
  Field,
  Form,
  Toast,
  FloatingBubble
} from 'vant'
import 'vant/lib/index.css'

Vue.use(Button)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(Field)
Vue.use(Form)
Vue.use(Toast)
// FloatingBubble 是 Vant 3+ 特性，Vant2 无此组件，用自定义替代
// Vue.use(FloatingBubble)

Vue.prototype.$axios = axios
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
